import { render, staticRenderFns } from "./TravelQuotations.vue?vue&type=template&id=6129d464&"
import script from "./TravelQuotations.vue?vue&type=script&lang=js&"
export * from "./TravelQuotations.vue?vue&type=script&lang=js&"
import style0 from "./TravelQuotations.vue?vue&type=style&index=0&id=6129d464&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports